// @flow

import React from 'react'
import { connect } from 'react-redux'
import { Image, Modal } from 'semantic-ui-react'
import { silver } from 'constants/inlineStyles'
import { thumbnailUrl } from '../../../../../../../shared/utils/URLs'

import ShareModalButtons from './ShareModalButtons'
import ModalContainer from './ModalContainer'

let styles = {}

type ReduxStateProps = {|
  ocrText: string,
  senderEmail: string,
  description: string,
  thumbnailURL: string,
  flyerTitle: string
|}

type Props = {|
  ...ReduxStateProps
|}

const ShareModal = ({
  ocrText,
  senderEmail,
  description,
  thumbnailURL,
  flyerTitle
}: Props) => (
  <ModalContainer
    header="Share Flyer"
    role="dialog"
    aria-modal="true"
    name="Share Modal"
  >
    <Modal.Content image style={styles.contentWrapper}>
      <Image
        wrapped
        size="small"
        className="mobile hidden"
        alt={`Image of a flyer titled ${flyerTitle}`}
        longdesc={`data:text/plain;charset=utf-8; Description - ${description} Text Found On Flyer - ${ocrText ||
          ' No Text Available'} Need more information on this flyer? You can email the person who submitted the flyer at ${senderEmail} to learn more.`}
        src={thumbnailURL}
        style={styles.largeSilverBorder}
      />
      <Modal.Description>
        <div style={styles.descriptionWrapper}>
          <ShareModalButtons flyerTitle={flyerTitle} />
        </div>
      </Modal.Description>
    </Modal.Content>
  </ModalContainer>
)

const mapStateToProps = (state): ReduxStateProps => {
  // TODO (quinkinser) create, use selectors
  const activeFlyerID = state.flyerDetails.activeFlyerId
  const flyer = state.flyers[activeFlyerID]
  return {
    ocrText: flyer.pages[0].ocr_text,
    senderEmail: flyer.seller_email,
    description: flyer.description,
    thumbnailURL: thumbnailUrl(flyer),
    flyerTitle: flyer.title
  }
}

styles = {
  largeSilverBorder: { border: `4px solid ${silver}` },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center'
  },
  descriptionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    textAlign: 'left',
    minWidth: '185px'
  }
}

export default connect(mapStateToProps)(ShareModal)



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/ModalManager/components/ShareModal.js